<template>
  <div class="page">
    <div class="page-header">
      <el-button type="text" icon="el-icon-arrow-left" @click="goBack">返回</el-button>
    </div>
    <el-tabs :stretch="true" v-model="infoType"  v-loading="loading" @tab-click="tabClick">
      <el-tab-pane label="基本信息" name="basic">
        <div class="card">
          <div class="item_box">
            <div class="avator" v-show="info.avatar_image" :style="{backgroundImage: 'url('+ info.avatar_image + ')' }"></div>
            <div class="item">
              <div class="title">客户名称</div>
              <div class="content"><span>{{info.name}}</span></div>
            </div>
            <div class="item">
              <div class="title">客户地址</div>
              <div class="content address"><span class="address_text">{{info.province + info.city + info.district + info.address}}</span>
                <el-button icon="el-icon-location" size="medium" type="text" @click="openLocation">导航</el-button>
              </div>
            </div>
            <div class="item">
              <div class="title">联系人及电话</div>
              <div class="content telephone">
                <div>{{info.contact_name}}</div>
                <template v-for="tel in info.telephone">
                  <div class="el-row--flex is-justify-space-between" :key="tel.number">
                    <div><span class="tel_tag">{{tel.tag ? tel.tag : '主要'}}</span> <span>{{tel.number}}</span></div>
                    <a class="main" :href="'tel:'+tel.number"><i class="el-icon-phone"></i></a>
                  </div>
                </template>

              </div>
            </div>
            <div class="item">
              <div class="title">业务经理</div>
              <div class="content"><span>{{info.seller && info.seller.name}}</span></div>
            </div>
            <div class="item">
              <div class="title">其他信息</div>
              <div class="content other">
                <div class="el-row--flex is-justify-space-between">
                  <div v-if="info.type_id !== null">客户类型: <span>{{info.type && info.type.name}}</span></div>
                  <div v-if="info.customer_business_ids !== null ">
                    主营: <span class="brand" v-for="(item,index) in info.customer_business" :key="index">{{item.name}}</span>
                  </div>
                </div>
                <div class="el-row--flex is-justify-space-between" style="margin: 5px 0">
                  <div>客户等级: {{info.level && info.level.name}}</div>
                  <div>复购情况: {{info.repurchase ? '可复购' : '不可复购'}}</div>
                </div>
                <div class="el-row--flex is-justify-space-between">
                  <div>录入: {{info.creator && info.creator.name}}</div>
                  <div>录入时间: <span>{{info.create_time}}</span></div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="title">业务进度</div>
              <div class="content">
                <div class="progress-text">
                  {{info.progress_status_text.full}}
                </div>
                <el-progress :show-text="false" :text-inside="true" :stroke-width="20" :color="progress.color" :percentage="progress.stage" ></el-progress>
              </div>
            </div>
          </div>
          <div class="bottom">
            <el-button  type="primary" @click="goEdit">修改信息</el-button>
            <el-upload
              ref="upload"
              action=""
              :show-file-list="false"
              :http-request="uploadAvatar"
              class="upload-demo"
              :before-upload="createData"
              :multiple="false">
              <el-button  type="primary">上传头像</el-button>
            </el-upload>
            <el-button  type="primary" @click="telephoneEditVisible = true">变更电话</el-button>
          </div>

          <el-dialog
            title="变更电话"
            :visible="telephoneEditVisible"
            width="95%"
            :show-close="false"
            center>

            <el-form :model="telephoneForm" ref="telephoneForm" :rules="telephoneRule" :label-width="formLabelWidth" status-icon>

              <el-form-item label="删除已有号码" label-width="100%" class="title"></el-form-item>

              <el-form-item label="已有">
                <el-tag
                  :key="item.id"
                  v-for="item in info.telephone"
                  closable
                  :disable-transitions="false"
                  @close="deleteTelephone(item.id)">
                  {{item.tag ? item.tag : '主要'}}:{{item.number}}
                </el-tag>
              </el-form-item>

              <el-form-item label="新增一个号码" label-width="100%" class="title"></el-form-item>

              <el-form-item label="号码"  prop="number">
                <el-input v-model.number="telephoneForm.number" type="number" placeholder="请输入电话号码"></el-input>
              </el-form-item>
              <el-form-item label="标签"  prop="tag">
                <el-input v-model="telephoneForm.tag"  placeholder="请输入此号码的备注标签"></el-input>
              </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
              <el-button @click="cancelTelephone">取 消</el-button>
              <el-button type="primary" @click="addTelephone('telephoneForm')">新 增</el-button>
            </span>
          </el-dialog>

        </div>
      </el-tab-pane>
      <el-tab-pane label="客户记录" name="records" :lazy="true">
        <div class="card">
          <div class="head">订单 <span class="danger">{{records && orderTotal}}</span> 元</div>
          <div class="item_box">
            <el-timeline>
              <template v-for="item in records">
                <el-timeline-item :timestamp="item.occur_time" placement="top" :key="item.id">
                  <el-card>
                    <h4 class="title">
                      <div>{{item.record_type && item.record_type.name}}</div>
                      <div v-if="item.money > 0">金额 <span>{{item.money}}</span> 元</div>
                    </h4>
                    <p class="content">{{item.content}}</p>
                    <div class="author info">
                      <div>{{item.creator.name}} 提交于 {{item.create_time}}</div>
                      <el-button type="text" size="mini" icon="el-icon-delete" @click="deleteRecord(item.id)">删除</el-button>
                    </div>
                  </el-card>
                </el-timeline-item>
              </template>
            </el-timeline>
          </div>
          <div class="bottom">
            <el-button  type="primary"  @click="recordAddVisible = true">添加记录</el-button>
          </div>

          <el-dialog
            title="添加记录"
            :visible.sync="recordAddVisible"
            width="95%"
            center>

            <el-form :model="recordForm" ref="recordForm" :rules="recordRule" :label-width="formLabelWidth">
              <el-form-item label="日期"  prop="occur_time">
                <el-date-picker
                  v-model="recordForm.occur_time"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="类型"  prop="trade_if">
                <el-radio-group v-model="recordForm.trade_if">
                  <el-radio label="1" border size="medium">订单</el-radio>
                  <el-radio label="0"  border size="medium">沟通</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="方式"  v-if="recordForm.trade_if==='0'" prop="record_type_id">
                <el-select v-model="recordForm.record_type_id" placeholder="请选择">
                  <el-option
                    v-for="item in record_types"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="金额"  v-if="recordForm.trade_if==='1'" prop="money">
                <el-input v-model.number="recordForm.money" type="number" placeholder="请输入订单金额"></el-input>
              </el-form-item>
              <el-form-item label="内容"  prop="content">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 10}"
                  placeholder="请输入内容"
                  v-model="recordForm.content">
                </el-input>
              </el-form-item>
              <el-form-item label="进度"  prop="progress_status">
                <el-radio-group v-model="recordForm.progress_status">
                  <template v-for="item of progress_status_options" >
                    <el-radio class="progress_status_radio" :label="item.id" :key="item.id"  v-if="item.id > 0 && item.id <4">{{item.full}}</el-radio>
                  </template>
                </el-radio-group>
              </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
              <el-button @click="cancelRecord">取 消</el-button>
              <el-button type="primary" @click="addRecord('recordForm')">确 定</el-button>
            </span>
          </el-dialog>

        </div>
      </el-tab-pane>
      <el-tab-pane label="客户相册" name="photos" :lazy="true">
        <div class="card">
          <el-row :gutter="10" v-if="info.images && info.images.length > 0" class="image_list">
            <el-col :span="12" v-for="img in info.images" :key="img.url" class="col">
              <el-image
                fit="cover"
                :src="img.url | remoteUrl"
                :preview-src-list="info.images | remoteImages">
                <div slot="placeholder">图片加载中...</div>
              </el-image>
              <div class="image_tag_box">
                <div class="image_tag">#{{img.tag || '未定义'}}#</div>
                <span>{{img.create_time || ''}}</span>
                <el-button type="text" size="mini" icon="el-icon-delete" @click="deleteImage(img.url)"></el-button>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-else>
            <el-col :span="24" class="no_image_tips">
              该客户暂无图片
            </el-col>
          </el-row>
          <div class="bottom">
            <el-upload
              ref="upload"
              action=""
              :show-file-list="false"
              :http-request="upload"
              class="upload-demo"
              :before-upload="createData"
              multiple>
              <el-button  type="primary">上传照片</el-button>
            </el-upload>

            <el-dropdown placement="top" trigger="click">
              <el-button type="primary">
                高级上传<i class="el-icon-arrow-up el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <template v-for="(tag,i) in imageTags" >
                  <el-upload
                  :key="i"
                  ref="upload"
                  action=""
                  :show-file-list="false"
                  :data="{tag: tag}"
                  :http-request="uploadImageWithTag"
                  class="upload-demo"
                  :before-upload="createData"
                  :multiple="false">
                    <el-dropdown-item slot="trigger" :command="tag" >{{tag}}</el-dropdown-item>
                  </el-upload>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Customer from '../api/customer'
import Telephone from '../api/telephone'
import Record from '../api/record'
import Upload from '../api/upload'

import { CONFIG } from '../config'
import wx from 'weixin-js-sdk'
export default {
  name: 'Info',
  data () {
    /* 自定义校验电话号码规则，亦可写在methods中(没必要) */
    const uniquePhone = (rule, value, callback) => {
      Telephone.check_phone(value).then(res => {
        if (res.data.code === 0) {
          callback(new Error('该客户号码已存在'))
        } else {
          callback()
        }
      })
    }
    return {
      loading: false, // 整页loading
      wxReady: false, // 微信JSSDK是否已就绪
      recordAddVisible: false, // 客户记录表单状态
      telephoneEditVisible: false, // 编辑电话表单
      records: null, // 客户记录
      info: { customer_business: null, progress_status_text: '' }, // 客户信息
      record_types: [], // 客户记录类型
      progress_status_options: [], // 业务跟进状态列表
      formLabelWidth: '50px', // 客户记录表单label宽度
      infoType: 'basic', // tabs初始展示页面
      ossBody: { host: '' }, // 后端返回的oss配置
      uploadData: {}, // oss上传参数
      file: null, // oss上传的文件
      allUploads: [], // Promise队列
      imageTags: [], // 图片标签设置
      recordForm: { // 客户记录表单
        customer_id: '',
        occur_time: '',
        trade_if: '',
        record_type_id: '',
        money: '',
        progress_status: '',
        content: ''
      },
      recordRule: { // 客户记录表单验证
        occur_time: [
          { required: true, message: '必须选择发生日期', trigger: 'change' }
        ],
        trade_if: [
          { required: true, message: '必须选择记录类型', trigger: 'change' }
        ],
        record_type_id: [
          { required: true, message: '必须选择沟通类型', trigger: 'change' }
        ],
        money: [
          { required: true, message: '必须输入交易金额', trigger: 'blur' },
          { type: 'number', message: '交易金额只能为数字', trigger: 'blur' }
        ],
        content: [
          { required: true, type: 'string', message: '必须输入内容', trigger: 'blur' }
        ],
        progress_status: [
          { required: true, message: '必须设置业务进度', trigger: 'change' }
        ]
      },
      telephoneForm: {}, // 电话表单
      telephoneRule: { // 电话表单验证
        number: [
          { required: true, message: '必须输入电话号码', trigger: 'blur' },
          { type: 'number', message: '电话号码只可以是数字', trigger: 'blur' },
          { validator: uniquePhone, trigger: 'blur' }
        ],
        tag: [
          { required: true, message: '请给此号码加一个标签', trigger: 'blur' }
        ]
      },
      shareConfig: { // 微信分享配置
        title: '',
        desc: '',
        link: '',
        imgUrl: 'http://oa.139tm.com/assets/img/crm-logo.png'
      }
    }
  },
  created () {
    this.getInfo()
    this.getSignature()
    this.getProgressStatus()
    this.getJssdkConfig()
    this.getRecordTypes()
    this.getImageTags()
  },
  methods: {
    getImageTags () {
      Customer.get_image_tags().then(res => {
        if (res.data.code === 1) {
          this.imageTags = res.data.data
        }
      })
    },
    deleteImage (url) {
      this.$confirm('确定删除这张照片吗?', {
        type: 'waining'
      }).then(() => {
        return Customer.delete_image(this.info.id, url)
      }).then(res => {
        if (res.data.data && res.data.code === 1) {
          this.$message.success('图片删除成功')
          this.info.images = res.data && res.data.code && res.data.data.images
        } else {
          this.$message.error(res.data.msg || '删除失败')
        }
      }).catch(res => {
        if (res !== 'cancel') {
          this.$message({
            type: 'info',
            message: '删除失败'
          })
        }
      })
    },
    getInfo () {
      this.loading = true
      let id = this.$route.params.id
      Customer.get_customer(id).then(res => {
        if (res.data && res.data.code === 1) {
          this.info = res.data.data

          this.info.avatar_image = this.info.avatar_image && CONFIG.FILE_URL + this.info.avatar_image

          this.recordForm.customer_id = this.info.id
          this.shareConfig.title = this.info.name
          this.shareConfig.desc = this.info.province + this.info.city + this.info.district + ' 业务经理:' + this.info.seller.name
          this.share()
        } else {
          let msg = res.data.msg || '获取用户数据出错'
          this.$alert(msg, '发生错误', {
            confirmButtonText: '好的',
            type: 'error',
            callback: () => {
              this.$router.push({ name: 'home' })
            }
          });
        }

        this.loading = false
      })
    },
    tabClick (tab, event) {
      if (tab.name === 'records' && !this.records) {
        this.getRecords()
      }
    },
    getRecords () {
      Record.get_records(this.info.id).then(res => {
        this.records = res.data.data
      })
    },
    getRecordTypes () {
      Record.get_record_types().then(res => {
        this.record_types = res.data.data
      })
    },
    getJssdkConfig () {
      let data = {
        url: CONFIG.isIOS()
          ? (sessionStorage.getItem('wx_landing_url') || window.location.href.split('#')[0])
          : window.location.href.split('#')[0],
        api: ['openLocation', 'getLocation', 'shareAppMessage', 'onMenuShareAppMessage', 'selectEnterpriseContact']
      }
      Customer.get_jssdk_config(data).then(res => {
        if (res.data.code === 1 && res.data.data.status) {
          wx.config(res.data.data.data)
          wx.ready(() => {
            this.wxReady = true
          })
          wx.error((err) => {
            console.error('wx jssdk config error', err)
            this.$message.error('微信JSSDK配置失败，导航功能可能不可用')
          })
        } else {
          this.$message.error(res.data.msg || '获取微信jssdk配置失败')
        }
      })
    },
    getProgressStatus () {
      Customer.get_progress_status().then(res => {
        if (res.data.data && res.data.code === 1) {
          this.progress_status_options = res.data.data
        } else {
          this.$message.error(res.data.msg || '获取客户进度信息失败')
        }
      })
    },
    getSignature () {
      Upload.get_signature().then(res => {
        this.ossBody = res.data.data
      })
    },
    createData (file) {
      this.loading = true
      this.file = file
      this.uploadData = {
        key: this.ossBody.dir + CONFIG.randomStr(10) + file.name,
        policy: this.ossBody.policy,
        OSSAccessKeyId: this.ossBody.accessid,
        success_action_status: '200', // 让服务端返回200,不然，默认会返回204
        callback: this.ossBody.callback,
        signature: this.ossBody.signature }
    },
    upload (file, fileList) {
      // 上传客户照片
      // 加入Promise队列，后续操作使用watch监听队列数组实现
      this.allUploads.push(
        Upload.oss_upload(this.ossBody.host, this.file, this.uploadData)
      )
    },
    uploadAvatar (file) { // 上传头像
      Upload.oss_upload(this.ossBody.host, this.file, this.uploadData).then(res => {
        let ret = res.data.data
        let img
        if (ret.Status === 'Ok') {
          let _data = decodeURIComponent(ret.data)
          let _arr = {}
          _data = _data.split('&')
          for (let i = 0; i < _data.length; i++) {
            let _temp = _data[i].split('=')
            _arr[_temp[0]] = _temp[1]
          }
          img = '/' + _arr.filename
        }
        return Customer.edit_customer({ id: this.info.id, avatar_image: img })
      }).then(res => {
        this.loading = false
        if (res.data.code === 1) {
          this.$message.success('头像上传成功')
          this.getInfo()
        }
      })
    },
    uploadImageWithTag (file) {
      Upload.oss_upload(this.ossBody.host, this.file, this.uploadData).then(res => {
        let ret = res.data.data
        let img
        if (ret.Status === 'Ok') {
          let _data = decodeURIComponent(ret.data)
          let _arr = {}
          _data = _data.split('&')
          for (let i = 0; i < _data.length; i++) {
            let _temp = _data[i].split('=')
            _arr[_temp[0]] = _temp[1]
          }
          img = '/' + _arr.filename
        }
        return Customer.add_image(this.info.id, [{ url: img, tag: file.data.tag }])
      }).then(res => {
        this.loading = false
        if (res.data.code === 1) {
          this.$message.success('图片上传成功')
          this.info.images = res.data && res.data.code && res.data.data.images
        }
      })
    },
    addRecord (form) { // 提交form
      if (this.loading) {
        return
      }
      this.loading = true
      this.$refs[form].validate(valid => {
        if (valid) {
          Record.add_record(this.recordForm).then(res => {
            if (res.data.code === 1) {
              this.$message.success('添加成功')
              this.getRecords()
              this.getInfo()
              this.cancelRecord()
              this.loading = false
            } else {
              this.$message.error(res.data.msg || '添加失败')
            }
          })
        } else {
          return false;
        }
      })
    },
    cancelRecord () {
      this.reset('recordForm')
      this.recordAddVisible = false
    },
    cancelTelephone () {
      this.reset('telephoneForm')
      this.telephoneEditVisible = false
    },
    reset (form) { // 重置form
      this.$refs[form].resetFields()
    },
    deleteRecord (id) {
      this.$confirm('确定删除此条往来记录?', {
        type: 'warning'
      }).then(() => {
        return Record.delete_record(id)
      }).then(res => {
        if (res.data.code === 1) {
          this.getRecords()
          this.$message.success('记录删除成功');
        } else {
          this.$message.error(res.data.msg || '记录删除失败')
        }
      }).catch((res) => {
        if (res !== 'cancel') {
          this.$message({
            type: 'info',
            message: '记录删除失败'
          })
        }
      })
    },
    addTelephone (form) {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$refs[form].validate(valid => {
        if (valid) {
          this.telephoneForm.customer_id = this.info.id
          Telephone.add_phone(this.telephoneForm).then(res => {
            if (res.data.data && res.data.code === 1) {
              this.$message.success('客户号码添加成功')
              this.info.telephone = res.data.data
              this.cancelTelephone()
              this.loading = false
            } else {
              this.$message.error(res.data.msg || '客户号码添加失败')
            }
          })
        }
      })
    },
    deleteTelephone (id) {
      this.$confirm('确定删除此号码吗?', {
        type: 'waining'
      }).then(() => {
        return Telephone.delete_phone(id)
      }).then(res => {
        if (res.data.data && res.data.code === 1) {
          this.$message.success('号码已被删除')
          this.info.telephone = res.data.data
        } else {
          this.$message.error(res.data.msg || '号码删除失败')
        }
      }).catch(res => {
        if (res !== 'cancel') {
          this.$message({
            type: 'info',
            message: '号码删除失败'
          })
        }
      })
    },
    goEdit () {
      this.$router.push({ name: 'edit', params: { id: this.info.id } })
    },
    goBack () {
      this.$router.go(-1)
    },
    openLocation: function () {
      let address = this.info.province + this.info.city + this.info.district + this.info.address
      new Promise((resolve, reject) => {
        this.loading = true
        if (this.info.latitude > 0 && this.info.longitude > 0) {
          resolve('direct')
        } else {
          resolve('get_map')
        }
      }).then(res => {
        if (res !== 'direct' && address) {
          return Customer.get_map_coordinate(address)
        }
      }).then(res => {
        this.loading = false
        if (res && res.data && res.data.code === 1) {
          this.info.latitude = res.data.data.result.location.lat
          this.info.longitude = res.data.data.result.location.lng
        }
        const launch = () => {
          wx.openLocation({
            latitude: parseFloat(this.info.latitude),
            longitude: parseFloat(this.info.longitude),
            name: this.info.name,
            address: address,
            scale: 14,
            infoUrl: 'http://oa.139tm.com',
            fail: (err) => {
              console.error('wx.openLocation failed', err)
              this.$message.error('打开地图失败：' + (err && err.errMsg ? err.errMsg : '未知错误'))
            }
          });
        }
        if (this.wxReady) {
          launch()
        } else {
          wx.ready(launch)
        }
      }).catch(res => {
        this.loading = false
        if (res && res.data && res.data.msg) {
          this.$message.error(res.data.msg)
        }
      })
    },
    share: function () {
      wx.onMenuShareAppMessage(this.shareConfig);
    }
  },
  computed: {
    orderTotal () {
      let order = this.records
      return order.reduce((total, current) => {
        let money = (current.money && parseFloat(current.money)) || 0
        return total + money
      }, 0)
    },
    progress () {
      let color = 'gray'
      let stage = 50
      switch (this.info.progress_status) {
        case '0':
          color = 'gray'
          stage = 30
          break
        case '1':
          color = '#e6a23c'
          stage = 50
          break
        case '2':
          color = '#409eff'
          stage = 75
          break
        case '3':
          color = '#67c23a'
          stage = 100
          break
        case '4':
          color = '#9e9e9e'
          stage = 90
          break
      }
      return { color: color, stage: stage }
    }
  },
  filters: {
    remoteUrl (value) {
      return CONFIG.FILE_URL + value
    },
    remoteImages (value) {
      return value.map(res => (CONFIG.FILE_URL + res.url))
    }
  },
  watch: {
    allUploads (values) {
      if (values && values.length > 0) {
        Promise.all(values).then(res => {
          let imgs = []
          for (let item of res) {
            let ret = item.data.data
            if (ret.Status === 'Ok') {
              let _data = decodeURIComponent(ret.data)
              let _arr = {}
              _data = _data.split('&')
              for (let i = 0; i < _data.length; i++) {
                let _temp = _data[i].split('=')
                _arr[_temp[0]] = _temp[1]
              }
              let img = '/' + _arr.filename
              imgs.push({ url: img, tag: '无' })
            }
          }
          // 修改客户图片信息
          return Customer.add_image(this.info.id, imgs)
        }).then(res => {
          this.loading = false
          this.$message.success('图片上传成功')
          this.allUploads = [] // 清空Promise队列，否则会累计执行
          this.info.images = res.data && res.data.code && res.data.data.images
        })
      }
    },
    recordForm: {
      handler (value) {
        if (value.trade_if > 0) {
          this.recordForm.record_type_id = null
        } else {
          this.recordForm.money = ''
        }
      },
      deep: true
    }

  }
}
</script>

<style lang="scss">
  $max-width: 600px;
  .page {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    margin: 0 8px;

    .page-header {
      padding: 8px 0;
    }

    .avator {
      height: 0;
      padding-bottom: 75%;
      background-size: cover;
      background-repeat: no-repeat;
    }

    .image_tag_box {
      display: flex;
      flex-flow: row nowrap;
      text-align: center;
      justify-content: space-between;
      line-height: 27px;

      margin-bottom: 20px;

      .image_tag {
        font-weight: bold;
        font-size: 12px;
        color: #303133;
      }
    }
  }
  .main {
    color: #409EFF;
  }
  .full {
    width: 100%
  }
  .progress_status_radio{
    margin-right: 15px;
    .el-radio__label {
      padding-left: 5px;
    }
  }
  .el-message-box {
    max-width: calc(100% - 30px);
  }
  .head {
    text-align: right;
    padding-bottom: 10px;
    border-bottom: 1px solid #DCDFE6;
    font-size: 14px
  }
  .foot {
    text-align: right;
    margin-top: -15px;
  }
  .card {
    .image_list {
      margin-bottom: 40px;
    }
    .bottom {
      position: fixed;
      bottom: 8px;
      max-width: $max-width;
      width: calc(100% - 16px);
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-around;
    }
    .el-form {
      .title {
        margin-bottom: 10px;
        .el-form-item__label {
          text-align: left;
          color: #409EFF;
          font-size: 16px;
        }
      }
      .el-tag {
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        width: 100%;
        text-align: center;
      }
    }
    .col {
      position: relative;
      .el-image{
        height: 0;
        padding-bottom: 75%;

        .el-image__inner{
          height: auto;
        }
      }
    }
    .no_image_tips {
      text-align: center;
      padding-top: 40px;
    }
    .item_box {
      margin-bottom: 54px;
      .el-timeline-item__wrapper {
        padding-left: 20px;
      }
      .el-timeline {
        margin: 0;
        padding: 10px 0 0 10px;

        h4.title {
          margin: 0;
        }
        p {
          margin: 5px 0;
          text-align: right;
        }
        .author, .title {
          display: flex;
          flex-flow: row nowrap;
          align-items: center;
          justify-content: space-between;
        }
        p.content {
          text-align: left
        }
      }
      .el-card__body {
        padding: 10px;
      }
    }
    .item {
      border-bottom: 1px solid #DCDFE6;
      margin-top: 15px;
      .title {
        font-family: "Microsoft YaHei UI Light", serif;
        font-size: 12px;
        color: #909399;
      }
      .content {
        font-size: 16px;
        color: #303133;
        padding: 8px 0 15px;
        .brand {
          padding: 0 2px;
        }
        .progress-text{
          position: absolute;
          z-index: 1;
          font-size: 12px;
          line-height: 20px;
          color: #fff;
          margin-left: 10px;
        }
      }
      .address {
        font-size: 14px;

        i {
          font-size: 16px;
          color: #409EFF;
        }
        .address_text {
          margin-right: 10px;
        }
      }
      .content.other {
        font-size: 12px;
        color: #606266;
        line-height: 1.5;
      }
      .telephone {
        line-height: 20px;
        padding-left: 20px;
        padding-right: 20px;
        .tel_tag {
          color: #409EFF;
          font-size: 12px;
        }
        i {
          color: #409EFF;
          font-size: 20px;
        }
      }
    }
  }
</style>
